import React, { useState } from "react";
import { 
  Bell as BellIcon, 
  ToastWarning as WarningIcon,
  ButtonCheck as SuccessIcon,
  Info as InfoIcon
} from "../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";
import { Close as CloseIcon } from "../icons/Close";

import "./style.scss";

const Notification = ({ 
  variant = 'info', 
  title = 'Notification',
  message,
  children,
  onClose,
  dismissible = true,
  persistent = false,
  className = '',
  iconVisible = true,
  actionButton,
  noHover = false,
  ...props 
}) => {
  
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  const getIcon = () => {
    switch (variant) {
      case 'success':
        return <SuccessIcon />;
      case 'warning':
        return <WarningIcon />;
      case 'error':
        return <WarningIcon />;
      case 'info':
      default:
        return <InfoIcon />;
    }
  };

  if (!isVisible && !persistent) {
    return null;
  }

  return (
    <div 
      className={`paylixecommerce-notification ${variant} ${noHover ? 'no-hover' : ''} ${className}`} 
      {...props}
    >
      <div className="paylixecommerce-notification-content">
        {iconVisible && (
          <div className="paylixecommerce-notification-icon">
            {getIcon()}
          </div>
        )}
        
        <div className="paylixecommerce-notification-body">
          <div className="paylixecommerce-notification-header">
            <h6 className="paylixecommerce-notification-title">{title}</h6>
            {dismissible && (
              <button 
                className="paylixecommerce-notification-close" 
                onClick={handleClose}
                aria-label="Close notification"
              >
                <CloseIcon />
              </button>
            )}
          </div>
          
          {message && (
            <div className="paylixecommerce-notification-message">
              {message}
            </div>
          )}
          
          {children && (
            <div className="paylixecommerce-notification-children">
              {children}
            </div>
          )}
          
          {actionButton && (
            <div className="paylixecommerce-notification-actions">
              {actionButton}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Additional notification variants as separate components for convenience
export const NotificationSuccess = (props) => (
  <Notification variant="success" {...props} />
);

export const NotificationWarning = (props) => (
  <Notification variant="warning" {...props} />
);

export const NotificationError = (props) => (
  <Notification variant="error" {...props} />
);

export const NotificationInfo = (props) => (
  <Notification variant="info" {...props} />
);

export default Notification;
